export const calendarStore = {
    state: () => ({
        weekDays: [
            { id: 0, order: 6, display: "Niedziela", key: "com.file.calendar-store.sunday" },
            { id: 1, order: 0, display: "Poniedziałek", key: "com.file.calendar-store.monday" },
            { id: 2, order: 1, display: "Wtorek", key: "com.file.calendar-store.tuesday" },
            { id: 3, order: 2, display: "Środa", key: "com.file.calendar-store.wednesday" },
            { id: 4, order: 3, display: "Czwartek", key: "com.file.calendar-store.thursday" },
            { id: 5, order: 4, display: "Piątek", key: "com.file.calendar-store.friday" },
            { id: 6, order: 5, display: "Sobota", key: "com.file.calendar-store.saturday" }],

        currentFirstDayOfWeek: { id: 0, order: 7, display: "Niedziela" },
        currentLastDayOfWeek: { id: 0, order: 7, display: "Niedziela" },
        currentDaysInMonth: 0,
        currentDate: null,
        todayDate: null,
        dataArray: [],
        isShowContenxtMenu: false,
        contextMenuPos: {
            x: 0,
            y: 0,
        },
        contextMenuDate: null,
    }),
    mutations: {

    },
}